import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'CompanyConfigurationCategoriesController',
            CompanyConfigurationCategoriesController
        );

    function CompanyConfigurationCategoriesController(
        CategoriesFactory,
        CompanyFactory,
        LocalStorageService
    ) {
        var vm = this;

        init();

        function init() {
            vm.pickFirst = vm.pickFirst !== false;
            if (!vm.company) {
                if (LocalStorageService.getObject('common/company')) {
                    getCategories(
                        LocalStorageService.getObject('common/company')
                            .organization.party_uuid,
                        {}
                    );
                } else {
                    getCompany();
                }
            } else {
                getCategories(vm.company, {});
            }
        }

        function getCategories(companyId, params) {
            CategoriesFactory.get(companyId, params).then(function (response) {
                vm.categories = response.data;

                if (vm.pickFirst && vm.categories.length === 1) {
                    vm.category = vm.categories[0].id;
                }
            });
        }

        function getCompany() {
            CompanyFactory.readCompany().then(function (response) {
                LocalStorageService.saveObject('common/company', response.data);
                getCategories(
                    LocalStorageService.getObject('common/company').organization
                        .party_uuid,
                    {}
                );
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/company_configuration/categories/categories.controller.ts